import { BANDEAU } from "../content/textes";

/** Bandeau permanent, non refermable. */
export function Bandeau() {
  return (
    <header className="bandeau" role="note">
      <strong>Où mettre les gares ?</strong> · {BANDEAU}
    </header>
  );
}
